import { Typography } from '@mui/material';
import React from 'react'

function Header({title}) {
  return (
    <Typography variant="displayLg">{title}</Typography>
  )
}

export default Header;